import * as actions from './actions'

export default {
	actions,
	state: {},
	namespaced: true
}
